import { MainWrapperViewImpl } from '../mainwrapperview';
import { ToolbarSearchComponent } from '../../toolkit/toolbarwithsearch/toolbarsearchcomponent';
import * as React from 'react';
import { ToolbarComponent } from '../../toolkit/toolbar/toolbarcomponent';
import { HomeWrapperComponentState } from './homewrappercomponent';
import { MobileMenuComponent } from '../../toolkit/mobilemenu/mobilemenucomponent';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { MainWrapperComponentHandler } from '../mainwrappercomponent';

export class HomeWrapperViewImpl extends MainWrapperViewImpl
{
    protected createToolBarComponent(): JSX.Element | boolean
    {
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            return <ToolbarSearchComponent onFlashMessageClicked={this.onFlashMessageClicked} categories={(this.getUIState() as HomeWrapperComponentState).categories} onCategoriesSelected={this.onCategorySelected} onDoItYourselfClicked={this.onDoItYourselfClicked}  onMyAccountOptionClicked={this.onMyAccountOptionClicked} onLogoClicked={this.onLogoClicked} context={this.getUIProps().context}/>;
        }
        else
        {
            return <ToolbarComponent onFlashMessageClicked={this.onFlashMessageClicked} categories={(this.getUIState() as HomeWrapperComponentState).categories} onSignInClicked={this.onSignInClicked} onCategoriesSelected={this.onCategorySelected} onDoItYourselfClicked={this.onDoItYourselfClicked}  onLogoClicked={this.onLogoClicked} context={this.getUIProps().context}/>;
        }
    }

    createMobileViewComponent()
    {
        return <MobileMenuComponent onLanguageChange={(language: LanguageConst) => (this.getUIComponentHandler() as MainWrapperComponentHandler).onLanguageChange(language)} categories={(this.getUIState() as HomeWrapperComponentState).categories} onCategoriesSelected={this.onCategorySelected} onDoItYourselfClicked={this.onDoItYourselfClicked}  onMyAccountOptionClicked={this.onMyAccountOptionClicked} onLogoClicked={this.onLogoClicked} context={this.getUIProps().context}/>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/homewrapperview.tsx